module.exports = __webpack_public_path__ + "img/auto-ins.7f3565df.svg";